import { css } from '@emotion/css';
import { theme } from '@repo-sapiens/theme';
import React, { useState, useEffect } from 'react';

export const ProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setProgress(100);
    }, 100); // small delay to ensure CSS transition runs

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div
      className={css`
        width: 100%;
        margin-top: 20px;
      `}
    >
      <div
        className={css`
          width: 100%;
          height: 5px;
          background-color: ${theme.colors.background.secondary};
          border-radius: 10px;
          overflow: hidden;
          margin-bottom: 10px;
        `}
      >
        <div
          className={css`
            height: 100%;
            background-color: ${theme.colors.text['highlight/1']};
            width: ${progress}%;

            transition: width 4.3s linear;
          `}
        />
      </div>
    </div>
  );
};
